import { render, staticRenderFns } from "./FallBackPage.vue?vue&type=template&id=f3c6202e&scoped=true"
import script from "./FallBackPage.vue?vue&type=script&lang=js"
export * from "./FallBackPage.vue?vue&type=script&lang=js"
import style0 from "./FallBackPage.vue?vue&type=style&index=0&id=f3c6202e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c6202e",
  null
  
)

export default component.exports